import axios, { AxiosError } from "axios";
import { decrypt, encrypt } from "utils/crypto";

function setInterceptor(instance: any) {
  axios.defaults.withCredentials = true;
  instance.defaults.baseURL = `${process.env.REACT_APP_API_URL}`;
  instance.defaults.withCredentials = true;

  instance.interceptors.request.use(async function (config: any) {
    const accessToken = localStorage.getItem("access-token") ?? sessionStorage.getItem("access-token");
    config.headers.Authorization = `Bearer ${decrypt(accessToken ?? "")}`;
    return config;
  });

  instance.interceptors.response.use(
    function (response: any) {
      return response;
    },
    async function (error: any) {
      if (!localStorage.getItem("access-token") && !sessionStorage.getItem("access-token")) {
        window.location.href = "/login";
      }
      if (error.response && error.response.status === 401 && !error.config._retry) {
        error.config._retry = true; // 무한 루프 방지

        return axios
          .post(`${process.env.REACT_APP_API_URL}/auth/silent-refresh`)
          .then((res) => {
            // 토큰을 localStorage 또는 sessionStorage에 저장
            if (res.data.user.autoLogin) {
              localStorage.setItem("access-token", encrypt(res.data.accessToken));
            } else {
              sessionStorage.setItem("access-token", encrypt(res.data.accessToken));
            }

            // 재발급된 토큰을 요청 헤더에 설정
            error.config.headers.Authorization = `Bearer ${res.data.accessToken}`;

            // 요청 재실행
            return instance(error.config); // 재요청을 return하여 결과 반환
          })
          .catch((refreshError) => {
            if (refreshError && refreshError.response && refreshError.response.status === 409) {
              alert("로그인이 만료되었습니다.");
              localStorage.clear();
              window.location.href = "/login";
            }
          });
      }
      return Promise.reject(error); // 에러 반환
    }
  );
  return instance;
}

function createInstance() {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
  });

  return setInterceptor(instance);
}

export const instance = createInstance();
